<template>
<div>
  <div class="mo_list">
    <!--设备通讯状态-->
    <div class="common_item">
      <div class="name_type">设备通讯状态</div>
      <div class="container_charts" :style="{height:rightHeight +'px'}">

        <div class="No" :style="{height:rightHeight+'px'}" :class="{'disabledNone':monitorGeneraldefault == 2}" >
            <img src="../../../static/img/Nodata.png">
            <span>暂无数据</span>
        </div>
        <div id="monitor_type1" :style="{height:rightHeight+'px'}"  :class="{'disabledNone':monitorGeneraldefault == 1}"></div>
      </div>
    </div>

    <div class="image-border image-border1"></div>
    <div class="image-border image-border2"></div>
    <div class="image-border image-border3"></div>
    <div class="image-border image-border4"></div>
  </div>


  <div class="mo_list" :class="{'disabledNone':swiperDefault == 2}">
    <!--实时监测信息-->
    <div class="common_item">
      <div class="name_type">设备实时信息</div>
      <div class="monitor_info innineNO" :style="{height:rightHeight+2+'px'}">
          <div class="No" :style="{height:rightHeight+2+'px'}"  >
            <img src="../../../static/img/Nodata.png">
            <span>暂无数据</span>
        </div>
      </div>

    </div>
    <div class="image-border image-border1"></div>
    <div class="image-border image-border2"></div>
    <div class="image-border image-border3"></div>
    <div class="image-border image-border4"></div>
  </div>


    <!--设备通讯统计-->
  <div class="mo_list" :style="{height:rightHeight+37+'px'}"  :class="{'disabledNone':swiperDefault == 1}">

    <div class="common_item" v-show="ISbureau == 'true'">
      <div class="name_type">设备通讯统计</div>
      <div class="container_charts" :style="{height:rightHeight+'px'}">
        <div id="real_type1" :style="{height:rightHeight+'px'}"></div>
      </div>
    </div>

    <!--实时监测信息-->
    <div class="common_item"  v-show="ISbureau == 'false'">
      <div class="name_type">设备实时信息</div>

    <!-- 告警大于六条 -->
    <!-- otherCurrentData.length>6 -->
    <div class="swiper_Wrap monitor_info" :style="{height:rightHeight+'px'}" v-if="otherCurrentData.length>6">
      <div class="monitor_info" :style="{height:rightHeight+listNormalHeight+'px'}" id="con2" ref="con2" :class="{anim:animate==true}">
        <div class="normal_item"  v-for="(otherItem,otherIndex) in otherCurrentData" :key="otherIndex" :style="{height:listNormalHeight+'px'}">
          <div class="info_item" @click="rote(otherItem)">
            <span class="icon_size">
              <i class="icon_type">
                <img :src="otherItem.imgSrc" alt="">
              </i>
            </span>
              <span class="item_name" style="cursor: pointer;">{{otherItem.thingjsName}}</span>
            <span class="info_type" v-html="otherItem.monitoringStatus"></span>
          </div>
        </div>
      </div>
    </div>
      <!-- 告警加正常小于6条 -->
     <div class="monitor_info" :style="{height:rightHeight+'px'}" v-if="otherCurrentData.length + normalCurrentData.length<=6" id="con2" ref="con2">
        <div class="normal_item"  v-for="(otherItem,otherIndex) in otherCurrentData" :key="otherIndex" :style="{height:listNormalHeight+'px'}">
          <div class="info_item" @click="rote(otherItem)">
            <span class="icon_size">
              <i class="icon_type">
                <img :src="otherItem.imgSrc" alt="">
              </i>
            </span>
              <span class="item_name" style="cursor: pointer;">{{otherItem.thingjsName}}</span>
            <span class="info_type" v-html="otherItem.monitoringStatus"></span>
          </div>
        </div>

        <div class="normal_item"  v-for="(otherItem,index) in normalCurrentData" :key="'info2-'+index" :style="{height:listNormalHeight+'px'}">
          <div class="info_item" @click="rote(otherItem)">
            <span class="icon_size">
              <i class="icon_type">
                <img :src="otherItem.imgSrc" alt="">
              </i>
            </span>
              <span class="item_name" style="cursor: pointer;">{{otherItem.thingjsName}}</span>
            <span class="info_type" v-html="otherItem.monitoringStatus"></span>
          </div>
        </div>
    </div>

    <!-- 告警加正常大于6条  告警等于6条 -->
     <div class="monitor_info" :style="{height:leftHeight+'px'}" v-if="otherCurrentData.length + normalCurrentData.length>6 && otherCurrentData.length==6" id="con1" ref="con1">
        <div class="normal_item"  v-for="(otherItem,otherIndex) in otherCurrentData" :key="otherIndex" :style="{height:listNormalHeight+'px'}">
          <div class="info_item" @click="rote(otherItem)">
            <span class="icon_size">
              <i class="icon_type">
                <img :src="otherItem.imgSrc" alt="">
              </i>
              <span class="icon_name">{{otherItem.monitorType}}</span>
            </span>
            <span v-if="otherItem.customerNameWidth<150" class="item_name" style="cursor: pointer;">{{otherItem.customerName}}</span>
              <span class="item_name" style="cursor: pointer;">{{otherItem.thingjsName}}</span>
            <span class="info_type" v-html="otherItem.monitoringStatus"></span>
          </div>
        </div>
    </div>

    <!-- 告警加正常大于6条告警小于六条 -->
     <div class="monitor_info" :style="{height:rightHeight+'px'}" v-if="otherCurrentData.length + normalCurrentData.length>6&&otherCurrentData.length<6">
        <div class="normal_item"  v-for="(otherItem,otherIndex) in otherCurrentData" :key="otherIndex" :style="{height:listNormalHeight+'px'}">
          <div class="info_item" @click="rote(otherItem)">
            <span class="icon_size">
              <i class="icon_type">
                <img :src="otherItem.imgSrc" alt="">
              </i>
            </span>
            <span class="item_name">{{otherItem.thingjsName}}</span>
            <span class="info_type" v-html="otherItem.monitoringStatus"></span>
          </div>
        </div>

         <div class="swiper_Wrap monitor_info" :style="{height:rightHeight +'px'}" >
           <div class="monitor_info" :style="{height:rightHeight+listNormalHeight+'px'}" id="con2" ref="con2" :class="{anim:animate==true}">
            <div class="normal_item"  v-for="(otherItem,index) in normalCurrentData" :key="'info2-'+index" :style="{height:listNormalHeight+'px'}">
              <div class="info_item" @click="rote(otherItem)">
                <span class="icon_size">
                  <i class="icon_type">
                    <img :src="otherItem.imgSrc" alt="">
                  </i>
                </span>
                <span class="item_name">{{otherItem.thingjsName}}</span>
                <span class="info_type" v-html="otherItem.monitoringStatus"></span>
              </div>
            </div>
          </div>
        </div>
    </div>
   </div>
   <div class="image-border image-border1"></div>
    <div class="image-border image-border2"></div>
    <div class="image-border image-border3"></div>
    <div class="image-border image-border4"></div>
 
  </div>
  
  
  <div class="mo_list" style='margin-top: 10px;' v-if="userType==3||userType==4">
    <!--报警处理统计-->
    <div class="common_item" style="overflow: inherit;" v-show="ISbureau == 'true'">
      <div class="name_type">报警处理统计</div>
      <div class="container_charts"  :style="{height:rightHeight+'px'}">
        <div class="No innineNO" style="width:100%;height:100%;" :class="{'disabledNone':warningdefault == 2}">
            <img src="../../../static/img/Nodata.png">
            <span>暂无数据</span>
        </div>
        <div id="warning_type8" :style="{height:rightHeight+37+'px'}"  :class="{'disabledNone':warningdefault == 1}"> 
        </div>
      </div>
    </div>

    <div class="common_item" style="overflow: inherit;" v-show="ISbureau == 'false'">
      <div class="name_type">报警处理统计</div>
      <div class="container_charts"  :style="{height:rightHeight+'px'}">
        <div class="No innineNO" style="width:100%;height:100%;" :class="{'disabledNone':warningdefault == 2}">
            <img src="../../../static/img/Nodata.png">
            <span>暂无数据</span>
        </div>      
          <div id="warning_type" :style="{height:rightHeight+'px'}"  :class="{'disabledNone':warningdefault == 1}"> 
          </div>
          
      </div>
    </div>


    <div class="image-border image-border1"></div>
    <div class="image-border image-border2"></div>
    <div class="image-border image-border3"></div>
    <div class="image-border image-border4"></div>
  </div>

    <!--报警处理统计-->
  <div class="mo_list" style='margin-top: 10px;' v-else-if="userType==0">
    <div class="common_item" style="overflow: inherit;" v-show="map3d=='false'">
      <div class="name_type">报警处理统计</div>
      <div class="container_charts"  :style="{height:rightHeight+'px'}">
        <div class="No innineNO" style="width:100%;height:100%;" :class="{'disabledNone':warningdefault == 2}">
            <img src="../../../static/img/Nodata.png">
            <span>暂无数据</span>
        </div>
        <div id="warning_type8" :style="{height:rightHeight+37+'px'}"  :class="{'disabledNone':warningdefault == 1}"> 
        </div>
      </div>
    </div>

    <div class="common_item" style="overflow: inherit;" v-show="map3d=='true'">
      <div class="name_type">报警处理统计</div>
      <div class="container_charts"  :style="{height:rightHeight+'px'}">
        <div class="No innineNO" style="width:100%;height:100%;" :class="{'disabledNone':warningdefault == 2}">
            <img src="../../../static/img/Nodata.png">
            <span>暂无数据</span>
        </div>
        <div id="warning_type" :style="{height:rightHeight+'px'}"  :class="{'disabledNone':warningdefault == 1}"> 
        </div>
      </div>
    </div>


    <div class="image-border image-border1"></div>
    <div class="image-border image-border2"></div>
    <div class="image-border image-border3"></div>
    <div class="image-border image-border4"></div>
  </div>


  <div class="mo_list" style='margin-top: 10px;' v-else>
    <div class="common_item" style="overflow: inherit;">
      <div class="name_type">报警处理统计</div>
      <div class="container_charts"  :style="{height:rightHeight+'px'}">
        <div class="No innineNO" style="width:100%;height:100%;" :class="{'disabledNone':warningdefault == 2}">
            <img src="../../../static/img/Nodata.png">
            <span>暂无数据</span>
        </div>
        <div id="warning_type" :style="{height:rightHeight+'px'}"  :class="{'disabledNone':warningdefault == 1}"> 
        </div>
      </div>
    </div>


    <div class="image-border image-border1"></div>
    <div class="image-border image-border2"></div>
    <div class="image-border image-border3"></div>
    <div class="image-border image-border4"></div>
  </div>

  

</div>  
</template>

<script>
import {ajaxFuncJson} from '@/api/ajax';
import { parseTime } from '@/utils';
// import refresh from '@/components/refresh';//上拉加载组件

export default {
  components: {
    // refresh,//注册上拉加载组件
  },
  //接收父组件websocket推送通知
  props: {
  },    
  name: 'mapRight',
  data () {
    return {
      userType: sessionStorage.getItem('userType') ,
     ISbureau:sessionStorage.getItem('ISbureau'),
     map3d:sessionStorage.getItem('map3d'),
     map3dIS:false,
      monitorTypeChart:'',
      
      deviceInfoData:{

      },
      monitorGeneraldefault:1,//设备通讯状态统计缺省页显示与否
      

      windowResize:null,
      rightHeight:'',

      warningdefault:1,//报警处理统计缺省页显示与否
      clearWarning:null,   //报警处理图表定时器
      warningData:[],

      listNormalHeight:'',
      clearInfo:null,   //实时监测信息定时器
      swiperDefault:1,//实时监测信息缺省页显示与否
      normalCurrentData:[],    //正常的实时监测信息
      otherCurrentData:[],     //非正常的实时监测信息
      animate:false,
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    },
    customerId() {
      return this.$store.state.bigScreenBuildingId;   //建筑id
    },
  },
  created() {
    var params;
        if(sessionStorage.getItem("userType") == 0){
          params=this.customerId;
        }else{
          // 校企端
          params = sessionStorage.getItem("customerId");
        }
    this.getDeviceInfo(params);
    this.getCurrentInfo(params);    //获取实时监测信息
    this.getWarnDetailData(params); //报警处理统计
    
  },
  mounted(){
    let that = this;
    that.windowResize=function () {
      that.rightHeight=(document.body.offsetHeight-287 - 10)/3;
      that.listNormalHeight=(document.body.offsetHeight-287)/18;
      that.initFont();
    };
    that.windowResize();
    window.addEventListener('resize',that.windowResize);
  },
  watch: {
    customerId(val){
      this.animate = false;   
      // clearTimeout(this.clearInfo);
      // clearTimeout(this.clearWarning);
            clearInterval(this.clearInfo);
      clearInterval(this.clearWarning);
      if(val){
        this.getDeviceInfo(val);
        this.getCurrentInfo(val);    //获取实时监测信息
        this.getWarnDetailData(val); //报警处理统计
      }else {
        this.getDeviceInfo();
        this.getCurrentInfo();    //获取实时监测信息
        this.getWarnDetailData(); //报警处理统计
      }
    }
  },
  methods:{
    getRight3D(){
    //  alert(sessionStorage.getItem('map3d'))
     this.map3d = sessionStorage.getItem('map3d')
      console.log('右侧刷新')
      this.ISbureau = sessionStorage.getItem('ISbureau');
      if(this.ISbureau == 'true'){
        this.swiperDefault = 2;
      }
      this.getDeviceInfo(this.customerId)//图一
      // this.getCurrentInfo(this.customerId)//图二
      this.getWarnDetailData(this.customerId)//图三

    },
    rote(id){
      sessionStorage.setItem('saveId',id.id)
      sessionStorage.setItem('buildingId',id.buildingId)
      sessionStorage.setItem('menuS',id.buildingId)
      this.$router.push({path:'/content/monitorDetails'})
      this.$router.push({path:'/content/monitorDetails', query:{buildingId:id.buildingId}})
    },
    // 监听到websocket变化父级调用
    watchWebsocket(val){
      this.animate = false;   
      // clearTimeout(this.clearInfo);
      // clearTimeout(this.clearWarning);
            clearInterval(this.clearInfo);
      clearInterval(this.clearWarning);
      
      if(val){
        this.getDeviceInfo(val);
        this.getCurrentInfo(val);    //获取实时监测信息
        this.getWarnDetailData(val); //报警处理统计
      }else {
        this.getDeviceInfo();
        this.getCurrentInfo();    //获取实时监测信息
        this.getWarnDetailData(); //报警处理统计
      }
    },

    //获取设备通讯状态数据接口-------------------------------------------------------------
    getDeviceInfo(val){
      if(this.userType == 3 || this.userType == 4){
        if(sessionStorage.getItem('ISbureau') == 'true'){
          ajaxFuncJson('/reginData/getMonitorGeneralSituation',{}).then(res=>{
            if(res.data.status==200){
              this.deviceInfoData=res.data.data;
              if(this.deviceInfoData.Data.length==0){
                this.monitorGeneraldefault = 1;
                return;
              }else{
                this.monitorGeneraldefault = 2;
              }
               let connectData = [];
               let normalData =[];
               let coordinateX = [];
               if(this.deviceInfoData.Data.length>0){
                  this.deviceInfoData.Data.forEach((a,b)=>{
                       connectData.push(a.connectData);
                       normalData.push(a.normalData);
                       if(a.type ==1){
                          a.type = {value:'电气',
                                      textStyle:{
                                      color:'#fff',
                                      }
                                    }
                       }else if(a.type ==2){
                          a.type = {value:'水压',
                                      textStyle:{
                                      color:'#fff',
                                      }
                                    }
                       }else if(a.type ==3){
                          a.type = {value:'液位',
                                      textStyle:{
                                      color:'#fff',
                                      }
                                    }
                       }else if(a.type ==4){
                          a.type = {value:'可燃气',
                                      textStyle:{
                                      color:'#fff',
                                      }
                                    }
                       }else if(a.type ==5){
                          a.type = {value:'烟感',
                                      textStyle:{
                                      color:'#fff',
                                      }
                                    }
                       }else if(a.type ==6){
                          a.type = {value:'灭火器',
                                      textStyle:{
                                      color:'#fff',
                                      }
                                    }
                       }else if(a.type ==7){
                          a.type = {value:'水浸',
                                      textStyle:{
                                      color:'#fff',
                                      }
                                    }
                       }else if(a.type ==8){
                          a.type = {value:'用传',
                                      textStyle:{
                                      color:'#fff',
                                      }
                                    }
                       }
                       coordinateX.push(a.type);
                  })
               }
              this.setEchart('monitor_type1',connectData,normalData,coordinateX);   //离线 故障  正常 各类型监测点数量
            }else {
              this.$message({
                message:res.data.msg,
                type:'error',
              })
            }
          });
        }else{
              var params={
                customerId:val,
              };
            ajaxFuncJson('/superviseIndex/monitorGeneralSituation',params).then(res=>{
              if(res.data.status==200){
                this.deviceInfoData=res.data.data;
                 if(this.deviceInfoData.Data.length==0){
                this.monitorGeneraldefault = 1;
                return;
              }else{
                this.monitorGeneraldefault = 2;
              }
               let connectData = [];
               let normalData =[];
               let coordinateX = [];
               if(this.deviceInfoData.Data.length>0){
                  this.deviceInfoData.Data.forEach((a,b)=>{
                       connectData.push(a.connectData);
                       normalData.push(a.normalData);
                       if(a.type ==1){
                          a.type = {value:'电气',
                                      textStyle:{
                                      color:'#fff',
                                      }
                                    }
                       }else if(a.type ==2){
                          a.type = {value:'水压',
                                      textStyle:{
                                      color:'#fff',
                                      }
                                    }
                       }else if(a.type ==3){
                          a.type = {value:'液位',
                                      textStyle:{
                                      color:'#fff',
                                      }
                                    }
                       }else if(a.type ==4){
                          a.type = {value:'可燃气',
                                      textStyle:{
                                      color:'#fff',
                                      }
                                    }
                       }else if(a.type ==5){
                          a.type = {value:'烟感',
                                      textStyle:{
                                      color:'#fff',
                                      }
                                    }
                       }else if(a.type ==6){
                          a.type = {value:'灭火器',
                                      textStyle:{
                                      color:'#fff',
                                      }
                                    }
                       }else if(a.type ==7){
                          a.type = {value:'水浸',
                                      textStyle:{
                                      color:'#fff',
                                      }
                                    }
                       }else if(a.type ==8){
                          a.type = {value:'用传',
                                      textStyle:{
                                      color:'#fff',
                                      }
                                    }
                       }
                       coordinateX.push(a.type);
                  })
               }
              this.setEchart('monitor_type1',connectData,normalData,coordinateX);   //离线 故障  正常 各类型监测点数量
              }else {
                this.$message({
                  message:res.data.msg,
                  type:'error',
                })
              }
            });
        }
      }else{
        var params={
           customerId:val,
         };
       ajaxFuncJson('/superviseIndex/monitorGeneralSituation',params).then(res=>{
         if(res.data.status==200){
           this.deviceInfoData=res.data.data;
            if(this.deviceInfoData.Data.length==0){
                this.monitorGeneraldefault = 1;
                return;
              }else{
                this.monitorGeneraldefault = 2;
              }
               let connectData = [];
               let normalData =[];
               let coordinateX = [];
               if(this.deviceInfoData.Data.length>0){
                  this.deviceInfoData.Data.forEach((a,b)=>{
                       connectData.push(a.connectData);
                       normalData.push(a.normalData);
                       if(a.type ==1){
                          a.type = {value:'电气',
                                      textStyle:{
                                      color:'#fff',
                                      }
                                    }
                       }else if(a.type ==2){
                          a.type = {value:'水压',
                                      textStyle:{
                                      color:'#fff',
                                      }
                                    }
                       }else if(a.type ==3){
                          a.type = {value:'液位',
                                      textStyle:{
                                      color:'#fff',
                                      }
                                    }
                       }else if(a.type ==4){
                          a.type = {value:'可燃气',
                                      textStyle:{
                                      color:'#fff',
                                      }
                                    }
                       }else if(a.type ==5){
                          a.type = {value:'烟感',
                                      textStyle:{
                                      color:'#fff',
                                      }
                                    }
                       }else if(a.type ==6){
                          a.type = {value:'灭火器',
                                      textStyle:{
                                      color:'#fff',
                                      }
                                    }
                       }else if(a.type ==7){
                          a.type = {value:'水浸',
                                      textStyle:{
                                      color:'#fff',
                                      }
                                    }
                       }else if(a.type ==8){
                          a.type = {value:'用传',
                                      textStyle:{
                                      color:'#fff',
                                      }
                                    }
                       }
                       coordinateX.push(a.type);
                  })
               }
              this.setEchart('monitor_type1',connectData,normalData,coordinateX);   //离线 故障  正常 各类型监测点数量
         }else {
           this.$message({
             message:res.data.msg,
             type:'error',
           })
         }
       });
      }
    },
    setEchart(el,offLine,normalData,coordinateX){
        this.monitorTypeChart=this.$echarts.init(document.getElementById(el));
        let cities = coordinateX;
        let citiesColor = [
          '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#607d8b;"></span>',
          '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#26c0c0;"></span>',
        ]
        this.monitorTypeChart.setOption({
          color:['#607d8b','#26c0c0'],
          angleAxis: {
            type: 'category',
            data: cities,
            z:10,
            boundaryGap:true,
            axisLine:{
              show:false
            },
            axisLabel:{
              show:true,
              padding:[0,0,0,0]
            }
          },
          radiusAxis: { //相当于二维坐标系的y坐标
            axisLine:{
              show:false
            },
            axisTick:{
              show:false,
            },
            axisLabel:{     //刻度标签
              show:false
            },
            splitLine:{ //分割线
              show:true,
              lineStyle:{
                  color:'#26304e'
              }
            },
          },
          backgroundColor:'rgba(31,34,68,.4)',
          polar: {
            radius:'50%',
          },
          tooltip : {
            show: true,
            formatter: function (params) {
              var id = params.dataIndex;
              return cities[id].value+'<br>'+ citiesColor[0]+'离线' + offLine[id]+'个<br>' + citiesColor[1]+'在线' + normalData[id]+'个<br>';
            },
            padding:10
          },
          series: [{
            type: 'bar',
            data: offLine,
            coordinateSystem: 'polar',     //极坐标系
            name: '离线',
            stack: 'a',
            barCategoryGap:'0',      //柱间距离
            label:{
              show:false,
              position: 'inside'
            },
          },{
            type: 'bar',
            data: normalData,
            coordinateSystem: 'polar',
            name: '在线',
            stack: 'a',
            barCategoryGap:'0',
          }],
          legend: {
            show: true,
            data:[{
                name:'离线',
                icon:'rect',
              },{
                name:'在线',
                icon:'rect',
            }],
            itemWidth:10,
            itemHeight:10,
            top:8,
            left:'center',
            textStyle:{
              color:'#fff',
              padding:[3,15,0,0]

            }
          }
        })
    },


      //获取设备通讯统计
    getCurrentInfo(val){
       var params={
          customerId:val,
        };
if(this.userType == 3||this.userType == 4){ //教育局
    if(sessionStorage.getItem('ISbureau') == 'true'){
      ajaxFuncJson('/reginData/getRegionMonitorLine',params).then(res=>{
        if(res.data.status==200){
          this.monitorData=res.data.data;
          let index=0;
          if(this.monitorData[index].empty){
            this.swiperDefault = 1;
          }else{
              this.swiperDefault = 2;
          }
              let customerNameArray = [];
              let onLineArray = [];
              let offLineArray = [];
              if(this.monitorData.length > 0){
                this.monitorData.forEach((a,b)=>{
                  customerNameArray.push(a.areaName);
                  onLineArray.push(a.onLine);
                  offLineArray.push(a.offLine);
                })
              }
          this.setEchart3('real_type1',customerNameArray,onLineArray,offLineArray);//正常 告警 预警
        }else {
          this.$message({
            type:'error',
            message:res.data.msg,
          })
        }
      });
    }else{
        ajaxFuncJson('/superviseIndex/realTimeDeviceInfo3D',params).then(res=>{
          if(res.data.status==200){
      // clearTimeout(this.clearInfo);
      // clearTimeout(this.clearWarning);

            this.otherCurrentData=[]; //告警
            this.normalCurrentData=[]; //正常
            // this.swiper.removeAllSlides();  //移出全部slides;
            // normalCurrentData:[],    //正常的实时监测信息
            // otherCurrentData:[],     //非正常的实时监测信息
            // 告警行置顶于正常行上方；
            // 当非正常运行行等于6条时，数据不滚动；
            // 当非正常运行行超过6条时，数据滚动轮播，每3秒向上移动一条；
            // 当非正常运行行小于6条时，告警行不滚动，其他行显示正常行，正常行滚动轮播，每3秒向上移动一条；

            if(res.data.data.length == 0){
              this.swiperDefault = 1;
            }else{
              this.swiperDefault = 2;
            }
            res.data.data.map((item,index)=>{
              if(item.connectStatus == false){
                let rcvName = ''
                if(item.type == 1){
                        rcvName = 'mA'
                }else if(item.type == 2){
                        if(item.rcv != -1){
                          item.rcv = item.rcv/1000 ;
                        }
                              rcvName = 'MPa'
                }else if(item.type == 3){
                        if(item.rcv != -1){
                          item.rcv = item.rcv/100 ;
                        }
                         rcvName = 'm'
                }else if(item.type == 4){
                        rcvName = '在线'
                }else if(item.type == 5){
                        rcvName = '在线'
                }else if(item.type == 6){
                        rcvName = 'MPa'
                }else if(item.type == 7){
                        rcvName = '在线'
                }else if(item.type == 8){
                        rcvName = '在线'
                }
                if(item.type == 4||item.type == 5||item.type == 7||item.type == 8){
                  item.monitoringStatus= '<span style="color: #4caf50">'+rcvName+'</span>';

                }else{
                  if(item.rcv == -1){
                       item.monitoringStatus= '<span style="color: #4caf50">****</span>';
                  }else{
                       item.monitoringStatus= '<span style="color: #4caf50">'+item.rcv+rcvName+'</span>';
                  }
                }
                this.normalCurrentData.push(item);
              }else {
                if(item.connectStatus == true){
                  item.monitoringStatus='<span style="color: #607d8b">离线</span>';
                }
                this.otherCurrentData.push(item);
              }
              if(item.type == 1){
                  item.imgSrc = './static/img/icon_electric.png'
              }else if(item.type == 2){
                  item.imgSrc = './static/img/icon_water.png'
              }else if(item.type == 3){
                  item.imgSrc = './static/img/icon_level.png'
              }else if(item.type == 4){
                  item.imgSrc = './static/img/icon_gas.png'
              }else if(item.type == 5){
                  item.imgSrc = './static/img/icon_smoke.png'
              }else if(item.type == 6){
                  item.imgSrc = './static/img/icon_bottol.png'
              }else if(item.type == 7){
                  item.imgSrc = './static/img/icon_ls.png'
              }else if(item.type == 8){
                  item.imgSrc = './static/img/icon_using.png'
              }
            });
            if(this.otherCurrentData.length>6){
              // console.log('离线大于6条')
              this.clearInfo = setInterval(()=>{
                  let con2 = this.$refs.con2;
                  $('#con2').css('margin-top','-'+this.listNormalHeight+'px')
                  this.animate=!this.animate;
                  var that = this; // 在异步函数中会出现this的偏移问题，此处一定要先保存好this的指向
                  // console.log(this.listNormalHeight)
                  setTimeout(function(){
                      that.otherCurrentData.push(that.otherCurrentData[0]);
                      that.otherCurrentData.shift();
                      $('#con2').css('margin-top','0px')
                      that.animate=false;  // 这个地方如果不把animate 取反会出现消息回滚的现象，此时把ul 元素的过渡属性取消掉就可以完美实现无缝滚动的效果了
                      // that.animate=!that.animate;  // 这个地方如果不把animate 取反会出现消息回滚的现象，此时把ul 元素的过渡属性取消掉就可以完美实现无缝滚动的效果了
                    //  console.log('右--------------')
                    //  console.log('右'+that.animate)
                  },500)
              },3000);
            }else if(this.otherCurrentData.length + this.normalCurrentData.length>6&&this.otherCurrentData.length<6){
              this.clearInfo = setInterval(()=>{
                  let con2 = this.$refs.con2;
                  $('#con2').css('margin-top','-'+this.listNormalHeight+'px')
                  this.animate=!this.animate;
                  var that = this; // 在异步函数中会出现this的偏移问题，此处一定要先保存好this的指向
                  setTimeout(function(){
                      that.normalCurrentData.push(that.normalCurrentData[0]);
                      that.normalCurrentData.shift();
                      $('#con2').css('margin-top','0px')
                      that.animate=false;  // 这个地方如果不把animate 取反会出现消息回滚的现象，此时把ul 元素的过渡属性取消掉就可以完美实现无缝滚动的效果了
                      // that.animate=!that.animate;  // 这个地方如果不把animate 取反会出现消息回滚的现象，此时把ul 元素的过渡属性取消掉就可以完美实现无缝滚动的效果了
                    //         console.log('右+++++++++++++++')
                    //  console.log('右'+that.animate)
                  },500)
              },3000);
            }
          }else {
            this.$message({
              type:'error',
              message:res.data.message,
            })
          }
        });
    }
}else{
  ajaxFuncJson('/superviseIndex/realTimeDeviceInfo3D',params).then(res=>{
    if(res.data.status==200){
      this.otherCurrentData=[]; //告警
      this.normalCurrentData=[]; //正常
      // this.swiper.removeAllSlides();  //移出全部slides;
      // normalCurrentData:[],    //正常的实时监测信息
      // otherCurrentData:[],     //非正常的实时监测信息
      // 告警行置顶于正常行上方；
      // 当非正常运行行等于6条时，数据不滚动；
      // 当非正常运行行超过6条时，数据滚动轮播，每3秒向上移动一条；
      // 当非正常运行行小于6条时，告警行不滚动，其他行显示正常行，正常行滚动轮播，每3秒向上移动一条；

      if(res.data.data.length == 0){
        this.swiperDefault = 1;
      }else{
        this.swiperDefault = 2;
      }
      res.data.data.map((item,index)=>{
        if(item.connectStatus == false){
          let rcvName = ''
          if(item.type == 1){
                  rcvName = 'mA'
          }else if(item.type == 2){
                  if(item.rcv != -1){
                    item.rcv = item.rcv/1000 ;
                  }
                  rcvName = 'MPa'
          }else if(item.type == 3){
              if(item.rcv != -1){
                item.rcv = item.rcv/100 ;
              }
               rcvName = 'm'
          }else if(item.type == 4){
                  rcvName = '在线'
          }else if(item.type == 5){
                  rcvName = '在线'
          }else if(item.type == 6){
                  rcvName = 'MPa'
          }else if(item.type == 7){
                        rcvName = '在线'
                }else if(item.type == 8){
                        rcvName = '在线'
                }
          if(item.type == 4||item.type == 5||item.type == 7||item.type == 8){

               item.monitoringStatus= '<span style="color: #4caf50">'+rcvName+'</span>';

          }else{
            if(item.rcv === -1){
                    item.monitoringStatus= '<span style="color: #4caf50">****</span>';
              }else{
                    item.monitoringStatus= '<span style="color: #4caf50">'+item.rcv+rcvName+'</span>';
              }
          }
          
          this.normalCurrentData.push(item);
        }else {
          if(item.connectStatus == true){
            item.monitoringStatus='<span style="color: #607d8b">离线</span>';
          }
          this.otherCurrentData.push(item);
        }
        if(item.type == 1){
            item.imgSrc = './static/img/icon_electric.png'
        }else if(item.type == 2){
            item.imgSrc = './static/img/icon_water.png'
        }else if(item.type == 3){
            item.imgSrc = './static/img/icon_level.png'
        }else if(item.type == 4){
            item.imgSrc = './static/img/icon_gas.png'
        }else if(item.type == 5){
            item.imgSrc = './static/img/icon_smoke.png'
        }else if(item.type == 6){
            item.imgSrc = './static/img/icon_bottol.png'
        }else if(item.type == 7){
            item.imgSrc = './static/img/icon_ls.png'
        }else if(item.type == 8){
            item.imgSrc = './static/img/icon_using.png'
        }
      });
      if(this.otherCurrentData.length>6){
        this.clearInfo = setInterval(()=>{
            let con2 = this.$refs.con2;
            $('#con2').css('margin-top','-'+this.listNormalHeight+'px')
            this.animate=!this.animate;
            var that = this; // 在异步函数中会出现this的偏移问题，此处一定要先保存好this的指向
            setTimeout(function(){
                that.otherCurrentData.push(that.otherCurrentData[0]);
                that.otherCurrentData.shift();
                $('#con2').css('margin-top','0px')
                that.animate=false;  // 这个地方如果不把animate 取反会出现消息回滚的现象，此时把ul 元素的过渡属性取消掉就可以完美实现无缝滚动的效果了
                // that.animate=!that.animate;  // 这个地方如果不把animate 取反会出现消息回滚的现象，此时把ul 元素的过渡属性取消掉就可以完美实现无缝滚动的效果了
                  // console.log('右--------------')
                  //    console.log('右'+that.animate)
            },500)
        },3000);
      }else if(this.otherCurrentData.length + this.normalCurrentData.length>6&&this.otherCurrentData.length<6){
         this.clearInfo = setInterval(()=>{
            let con2 = this.$refs.con2;
            $('#con2').css('margin-top','-'+this.listNormalHeight+'px')
            this.animate=!this.animate;
            var that = this; // 在异步函数中会出现this的偏移问题，此处一定要先保存好this的指向
            setTimeout(function(){
                that.normalCurrentData.push(that.normalCurrentData[0]);
                that.normalCurrentData.shift();
                $('#con2').css('margin-top','0px')
                that.animate=false;  // 这个地方如果不把animate 取反会出现消息回滚的现象，此时把ul 元素的过渡属性取消掉就可以完美实现无缝滚动的效果了
                // that.animate=!that.animate;  // 这个地方如果不把animate 取反会出现消息回滚的现象，此时把ul 元素的过渡属性取消掉就可以完美实现无缝滚动的效果了
                  // console.log('右--------++------')
                  //    console.log('右'+that.animate)
            },500)
        },3000);
      }
    }else {
      this.$message({
        type:'error',
        message:res.data.message,
      })
    }
  });
}
    },
    setEchart3(el,name,onLine,offLine){
        this.monitorTypeChart1=this.$echarts.init(document.getElementById(el));
        let cities = name;
        let citiesColor = [
          '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#d7504b;"></span>',
          '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#fe8463;"></span>',
          '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#607d8b;"></span>',
          '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#26c0c0;"></span>',
        ]
        this.monitorTypeChart1.setOption({
          color: ['#607d8b','#26c0c0'],
          tooltip : {
            show: true,
            formatter: function (params) {
              var id = params.dataIndex;
              return cities[id]+'<br>' + citiesColor[2]+'离线' + offLine[id]+'个<br>'+ citiesColor[3]+'在线' + onLine[id]+'个<br>';
            },
            padding:10
          },
          legend: {
            orient:'horizontal',
            data: [
              {
                name:'离线',
                icon:'rect',
              },{
                name:'在线',
                icon:'rect',
              }],
            itemWidth:10,
            itemHeight:10,
            top:20,
            left:'center',
            textStyle:{
              color:'#fff',
              padding:[3,15,0,0]
            }
          },
          grid: {
            top:'26%',
            left: '18',
            right: '35',
            bottom: '5%',
            containLabel: true
          },
          yAxis:  {
            type: 'category',
            data: cities,
            offset:5,
            axisTick: {
              // alignWithLabel: true,
              show: false
            },
            axisLabel:{
              color:'#fff',
              interval:0,
            },
            axisLine:{
              lineStyle: {
                color:'#0077ff'
              }
            },
            name: '区',
            nameTextStyle: {
                color: '#fff'
            }
          },
          xAxis: {
            type: 'value',
            minInterval: 1,
            axisLabel:{
              color:'#fff',
            },
            axisTick: {
              // alignWithLabel: true,
              show: false
            },
            axisLine:{
              lineStyle: {
                color:'#0077ff'
              }
            },
            splitLine:{
                show:true,
                lineStyle:{
                    color:'#26304e'
                }
            },
            name: '个',
            nameTextStyle: {
                color: '#fff'
            }
          },
          backgroundColor:'rgba(31,34,68,.4)',
          series: [
            {
              name: '离线',
              type: 'bar',
              stack: '总量',
              barWidth : 8,//柱图宽度
              label: {
                normal: {
                  show: false,
                  position: 'insideRight'
                }
              },
              data: offLine,
            },
            {
              name: '在线',
              type: 'bar',
              stack: '总量',
              barWidth : 8,//柱图宽度
              label: {
                normal: {
                  show: false,
                  position: 'insideRight'
                }
              },
              data: onLine,
            }
          ]
        });
    },


    //获取报警处理统计数据
    getWarnDetailData(val){
            var params={
              customerId:val
            };
            if(this.userType ==3 || this.userType ==4){
                 if(sessionStorage.getItem('ISbureau') == 'true'){
                   ajaxFuncJson('/reginData/getAlarmProcStatistics',{}).then(res=>{
                     if(res.data.status==200){
                       this.warningData=res.data.data;
                       if(this.warningData.alreadHandle==0&&this.warningData.unHandle==0){
                         this.warningdefault = 1;
                       }else{
                         this.warningdefault = 2;
                       }
                     this.setWarnEchart2('warning_type8',this.warningData.areaName,this.warningData.alreadHandle,this.warningData.unHandle);
                     }else {
                       this.$message({
                         type:'error',
                         message:res.data.msg,
                       })
                     }
                   });
                 }else{
                    ajaxFuncJson('/superviseIndex/alarmProcessStatistics',params).then(res=>{
                      if(res.data.status==200){
                        this.warningData=res.data.data;
                        let index=0;
                        if(this.warningData[index].dealTime.length ==0){
                          this.warningdefault = 1;
                        }else{
                          this.warningdefault = 2;
                        }

                            let dealTime = [];
                             let coordinateX =[];
                            if(this.warningData[index].dealTime.length>0){
                                this.warningData[index].dealTime.forEach((a,b)=>{
                                    dealTime.push(a.typeCount);
                                    if(a.type ==1){
                                        a.type = '电气';
                                    }else if(a.type ==2){
                                        a.type = '水压';
                                    }else if(a.type ==3){
                                        a.type = '液位';
                                    }else if(a.type ==4){
                                        a.type = '可燃气';
                                    }else if(a.type ==5){
                                        a.type = '烟感';
                                    }else if(a.type ==6){
                                        a.type = '灭火器';
                                    }else if(a.type ==7){
                                        a.type = '水浸';
                                    }else if(a.type ==8){
                                        a.type = '用传';
                                    }
                                    coordinateX.push(a.type);
                                })
                            }
                        this.setWarnEchart('warning_type',this.warningData[0].customerName,dealTime,this.warningData.averDealTime,coordinateX);
                      }else {
                        this.$message({
                          type:'error',
                          message:res.data.msg,
                        })
                      }
                    });
                 }

          }else if(this.userType == 0){
                 if(this.map3d == 'false'){
                   ajaxFuncJson('/superviseIndex/getAlarmProcStatistics',{}).then(res=>{
                     if(res.data.status==200){
                       this.warningData=res.data.data;
                       if(this.warningData.alreadHandle==0&&this.warningData.unHandle==0){
                         this.warningdefault = 1;
                       }else{
                         this.warningdefault = 2;
                       }
                     this.setWarnEchart2('warning_type8',this.warningData.areaName,this.warningData.alreadHandle,this.warningData.unHandle);
                     }else {
                       this.$message({
                         type:'error',
                         message:res.data.msg,
                       })
                     }
                   });
                 }else{
                    ajaxFuncJson('/superviseIndex/alarmProcessStatistics',params).then(res=>{
                      if(res.data.status==200){
                        this.warningData=res.data.data;
                        let index=0;
                        if(this.warningData[index].dealTime.length ==0){
                          this.warningdefault = 1;
                        }else{
                          this.warningdefault = 2;
                        }

                            let dealTime = [];
                             let coordinateX =[];
                            if(this.warningData[index].dealTime.length>0){
                                this.warningData[index].dealTime.forEach((a,b)=>{
                                    dealTime.push(a.typeCount);
                                    if(a.type ==1){
                                        a.type = '电气';
                                    }else if(a.type ==2){
                                        a.type = '水压';
                                    }else if(a.type ==3){
                                        a.type = '液位';
                                    }else if(a.type ==4){
                                        a.type = '可燃气';
                                    }else if(a.type ==5){
                                        a.type = '烟感';
                                    }else if(a.type ==6){
                                        a.type = '灭火器';
                                    }else if(a.type ==7){
                                        a.type = '水浸';
                                    }else if(a.type ==8){
                                        a.type = '用传';
                                    }
                                    coordinateX.push(a.type);
                                })
                            }
                        this.setWarnEchart('warning_type',this.warningData[0].customerName,dealTime,this.warningData.averDealTime,coordinateX);
                      }else {
                        this.$message({
                          type:'error',
                          message:res.data.msg,
                        })
                      }
                    });
                 }
            }else{
                  ajaxFuncJson('/superviseIndex/alarmProcessStatistics',params).then(res=>{
                      if(res.data.status==200){
                        this.warningData=res.data.data;
                        let index=0;
                        if(this.warningData[index].dealTime.length ==0){
                          this.warningdefault = 1;
                        }else{
                          this.warningdefault = 2;
                        }

                            let dealTime = [];
                             let coordinateX =[];
                            if(this.warningData[index].dealTime.length>0){
                                this.warningData[index].dealTime.forEach((a,b)=>{
                                    dealTime.push(a.typeCount);
                                    if(a.type ==1){
                                        a.type = '电气';
                                    }else if(a.type ==2){
                                        a.type = '水压';
                                    }else if(a.type ==3){
                                        a.type = '液位';
                                    }else if(a.type ==4){
                                        a.type = '可燃气';
                                    }else if(a.type ==5){
                                        a.type = '烟感';
                                    }else if(a.type ==6){
                                        a.type = '灭火器';
                                    }else if(a.type ==7){
                                        a.type = '水浸';
                                    }else if(a.type ==8){
                                        a.type = '用传';
                                    }
                                    coordinateX.push(a.type);
                                })
                            }
                        this.setWarnEchart('warning_type',this.warningData[0].customerName,dealTime,this.warningData.averDealTime,coordinateX);
                      }else {
                        this.$message({
                          type:'error',
                          message:res.data.msg,
                        })
                      }
                    });
          }
    },
    //轮播报警处理统计图表
    slideWarning(controlTime,length,index){
      this.clearWarning=setTimeout(()=>{
        index++;
        let currentDataIndex=index%length;
        if(this.warningData[currentDataIndex].empty){
          this.warningdefault = 1;
        }else{
          this.warningdefault = 2;
        }
        this.warningData[currentDataIndex].dealTimeArray = [];
        this.warningData[currentDataIndex].coordinateX = [];
                        this.warningData[currentDataIndex].dealTime.forEach((a,b)=>{
                            this.warningData[currentDataIndex].dealTimeArray.push(a.typeCount);
                            if(a.type ==1){
                                a.type = '电气';
                            }else if(a.type ==2){
                                a.type = '水压';
                            }else if(a.type ==3){
                                a.type = '液位';
                            }else if(a.type ==4){
                                a.type = '可燃气';
                            }else if(a.type ==5){
                                a.type = '烟感';
                            }else if(a.type ==6){
                                a.type = '灭火器';
                            }else if(a.type ==7){
                                a.type = '水浸';
                            }else if(a.type ==8){
                                a.type = '用传';
                            }
                            this.warningData[currentDataIndex].coordinateX.push(a.type);
                        })
        this.setWarnEchart('warning_type',this.warningData[currentDataIndex].customerName,this.warningData[currentDataIndex].dealTimeArray,this.warningData[currentDataIndex].averDealTime,this.warningData[currentDataIndex].coordinateX);
        this.slideWarning(controlTime,length,index);
      },controlTime);
    },
    setWarnEchart(el,name,averData,levelTip,typeName){
      this.monitorTypeChart=this.$echarts.init(document.getElementById(el));
      this.monitorTypeChart.setOption({
        color:['#26c0c0'],
        title: {
          text:name,
          left:'center',
          textStyle: {
            color: '#27ADB1',
            fontSize: '14',
            lineHeight:'14',
            fontWeight: 'normal'
          },
        },
        tooltip : {
           show: true,
            formatter: function (params) {
              if(params.componentType == 'markLine'){
                var id = params.dataIndex;
                return '平均值：'+ params.value;
                
              }else{
                var id = params.dataIndex;
                return params.name+'<br>'+ params.marker+'处理时长：'+ averData[id]+'min';
              }
              
            },
            padding:10
        },
        grid: {
          left: '20',
          right: '20',
          bottom: '5%',
          containLabel: true
        },
        xAxis:  {
          type: 'category',
          data:typeName,
          //  ['电气','水压','液位','可燃气','烟感','灭火器','水浸'],
          offset:5,
          axisTick: {
            // alignWithLabel: true,
            show: false
          },
          axisLabel:{
            color:'#fff',
            interval: 0
          },
          axisLine:{
            lineStyle: {
              color:'#0077ff'
            }
          }
        },
        backgroundColor:'rgba(31,34,68,.4)',
        yAxis: {
          type: 'value',
          name:'min',
          nameTextStyle: {
                color: '#fff'
          },
          axisTick: {
            show: false
          },
          axisLabel:{
            color:'#fff',
          },
          axisLine:{
            lineStyle: {
              color:'#0077ff'
            }
          },
          splitLine:{
              show:true,
              lineStyle:{
                  color:'#26304e'
              }
          },
        },
        series: [
          {
            type: 'bar',
            barWidth : 8,//柱图宽度
            label: {
              normal: {
                show: false,
                position: 'insideRight'
              }
            },
            data:averData,
            markLine : {
              symbol: 'none',
              silent:false,
              hoverAnimation: false,
              lineStyle :{
                type:'dashed',
                color:'#1980ff',
                width:1,//折线宽度
              },
              itemStyle: { 
                normal: {
                    color:'#1980ff',
                    width:1,//折线宽度
                    label: {
                        formatter: ''
                    },
                }
                }, 
              data : [
                {type : 'average',
                  name: '平均值'
                },                   
              ]
            }

        
          },
        ]
      });
    },
    setWarnEchart2(el,name,averData,levelTip){
      this.monitorTypeChart=this.$echarts.init(document.getElementById(el));
      let citiesColor = [
          '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#d7504b;"></span>',
          '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#fe8463;"></span>',
          '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#607d8b;"></span>',
          '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#26c0c0;"></span>',
        ]
      this.monitorTypeChart.setOption({
        color:['#26c0c0','#fe8463'],
        tooltip : {
            show: true,
             formatter: '{a} <br/>'+(new Date().getMonth()+1)+'月{b} : {c} ({d}%)',
            padding:10
          },
          legend: {
            orient:'horizontal',
            data: [
              {
                name:'未处理',
                icon:'rect',
              },{
                name:'已处理',
                icon:'rect',
              }],
            itemWidth:10,
            itemHeight:10,
            top:20,
            left:'center',
            textStyle:{
              color:'#fff',
              padding:[3,15,0,0]
            }
          },
        grid: {
          left: '20',
          right: '20',
          bottom: '5%',
          containLabel: true
        },
        backgroundColor:'rgba(31,34,68,.4)',
        series: [
          {
            name:name,
            type: 'pie',
            radius: '50%',
            data: [
            {value: averData, name: '已处理'},
            {value: levelTip, name: '未处理'}
        ],
          },
        ]
      });
    },

    // 宽高自适应
    initFont() {
      let that = this;
      setTimeout(function(){
        that.$echarts.init(document.getElementById('monitor_type1')).resize({width: null, height: null});
        that.$echarts.init(document.getElementById('real_type1')).resize({width: null, height: null});
        that.$echarts.init(document.getElementById('warning_type')).resize({width: null, height: null});
        that.$echarts.init(document.getElementById('warning_type8')).resize({width: null, height: null});
      },100)
    },
  },
  destroyed() {
    window.removeEventListener("resize",this.windowResize);
    this.animate = false;
    // clearTimeout(this.clearInfo);
    // clearTimeout(this.clearWarning);
        clearInterval(this.clearInfo);
    clearInterval(this.clearWarning);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .mo_list{
  position: relative;
  background: rgba(44,40,84,.4);
cursor: pointer;
}

  .image-border {
	position: absolute;
	width: 20px;
	height: 20px;
}
		
.image-border1 {
	top: 0;
	left: 0;
	border-left: 1px solid #00b0ff;
	border-top: 1px solid #00b0ff;
}
		
.image-border2 {
	top: 0;
	right: 0px;
	border-right: 1px solid #00b0ff;
	border-top:1px solid #00b0ff;
}
		
.image-border3 {
	bottom: 0;
	left: 0;
	border-bottom: 1px solid #00b0ff;
	border-left: 1px solid #00b0ff;
}
		
.image-border4 {
	bottom: 0;
	right: 0px;
	border-right: 1px solid #00b0ff;
	border-bottom: 1px solid #00b0ff;
}

   .swiper_Wrap{
    width:100%;
    overflow: hidden;
  }
  #box{
    
    transition: all 0.5s;
  }
  .anim{
    transition: all 0.5s;
  }


  .common_item {
    width: 360px;
    position: relative;
    border: 1px solid #264480;
    margin-bottom: 10px;
    overflow: hidden;
    .name_type {
      font-size: 14px;
      font-weight: bold;
      color: #00b0ff;
      line-height: 35px;
      padding-left: 20px;
      background: rgba(44, 40, 84, 0.4);
      position: relative;
    }
    .innineNO{
      background: rgba(31,34,68,.4);
    }
    .container_charts {
      width: 360px;
      position: relative;
      #monitor_type1 {
        height: 255px;
        width: 360px;
      }
      #warning_type{
        width: 360px;
      }
      #warning_type8{
        width: 360px;
      }
      #real_type1{
        width: 360px;
      }
      .tip_info{
        position: absolute;
        width: 100%;
        bottom: 20px;
        text-align: center;
        font-size: 13px;
        color: #fff;
      }
    }
    .monitor_info{
        background: rgba(31,34,68,.4);

      .monitor_container{
        height: 100%;
        .info_item{
          display: flex;
          height: 100%;
          align-items: center;
          padding: 0 20px;
          font-size: 13px;
          color: #fff;
          position: relative;
          .icon_size{
            display: inline-block;
            width: 90px;
            margin-top: 2px;
            .icon_name{
              position: relative;
              top:-4px;
            }
            .icon_type{
              display: inline-block;
              width: 20px;
              height: 20px;
              border-radius: 50%;
              margin-right: 10px;
            }
          }
          .item_name{
            color: #26c0c0;
            width:150px;
            overflow:hidden;
            white-space:nowrap ;   
            text-overflow:ellipsis;
          }
          .info_type{
            position: absolute;
            right: 20px;
            width: 100px;
            text-align: right;
          }
        }
      }
      .normal_item{
        /*height: 42.5px;*/
        // background: rgba(31,34,68,.4);
        .info_item{
          display: flex;
          height: 100%;
          align-items: center;
          padding: 0 20px;
          font-size: 13px;
          color: #fff;
          position: relative;
          .icon_size{
            display: inline-block;
            width: 70px;
            margin-top: 2px;
            .icon_name{
              position: relative;
              top:-4px;
            }
            .icon_type{
              display: inline-block;
              width: 20px;
              height: 20px;
              border-radius: 50%;
              margin-right: 10px;
            }
          }
          .item_name{
            color: #26c0c0;
            width:180px;
            overflow:hidden;
            white-space:nowrap ;   
            text-overflow:ellipsis;
          }
          .info_type{
            position: absolute;
            right: 20px;
            width: 100px;
            text-align: right;
          }
        }
      }
    }
  }
  .disabledNone{
    display: none;
  }
  .No{
   padding-top:10%;
  }
  .No span {
    font-size: 14px;
    color: #f5f5f5;
  }
  .No img {
    margin: 0 auto 0px;
  }



</style>



// WEBPACK FOOTER //
// src/page/home/mapRight.vue